import {EU_COUNTRIES} from "./euVatValidator";

export function getVatCountryPrefix(countryCode) {
    if (!countryCode || countryCode === 'PL') {
        return '';
    }
    if (countryCode === 'GR') {
        return 'EL';
    }
    if (EU_COUNTRIES.includes(countryCode)) {
        return countryCode;
    }
    return '';
}
